import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Content from "../../../Components/Dashboard/Content/Content";
import { getCompanyByIP } from "../../../Service/admin.service";

const Pi42 = () => {
  const [company, setCompany] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCompanyData();
  }, []);

  const fetchCompanyData = async () => {
    try {
      // const res = await getCompanyByIP("185.209.75.31");
           const res = await getCompanyByIP("151.242.51.138");
      if (res?.status) setCompany(res.data);
    } catch (error) {
      console.error("Error fetching company:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Content
      Page_title="Pi42 - API & Integration Guide"
      button_title="Back"
      route="/admin/apicreateinfo"
    >
      <div className="container pb-5">
        <div className="mb-4">
          <h3 className="fw-bold">Pi42 API — Complete Integration Guide</h3>
          <p className="text-muted">
            Learn how to generate an API Key & Secret Key on Pi42 and integrate
            it into your trading system.
          </p>
        </div>

        {/* Intro Section */}
        <div className="card shadow-sm border-0 mb-4">
          <div className="card-body">
            <p>
              Pi42 provides an INR-margined crypto futures trading platform
              supporting automated strategies, real-time market data, and secure
              account management.
            </p>
            <p className="small text-muted">
              Official Website:{" "}
              <a
                href="https://pi42.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                pi42.com
              </a>
            </p>
          </div>
        </div>

        {/* Steps */}
        <div className="card shadow-sm border-0 p-4 rounded-3">
          <h4 className="fw-semibold mb-4">
            Step-by-Step: Generate API Key & Secret Key
          </h4>

          <ol className="ps-3">

            {/* Step 1 */}
            <li className="mb-4">
              <strong>Step 1:</strong> Visit{" "}
              <a
                href="https://pi42.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                pi42.com
              </a>{" "}
              and log in to your account.
              <div className="mt-3 text-center">
                <img
                  src="/assets/images/Pi42/first-pi42.png"
                  alt="Login Page"
                  className="img-fluid rounded shadow-sm"
                  style={{ maxWidth: "750px" }}
                />
              </div>
            </li>

            {/* Step 2 */}
            <li className="mb-4">
              <strong>Step 2:</strong> Click your{" "}
              <strong>Profile Icon</strong> → Select <strong>API Keys</strong>.
              <div className="mt-3 text-center">
                <img
                  src="/assets/images/Pi42/Second.png"
                  alt="API Key Menu"
                  className="img-fluid rounded shadow-sm"
                  style={{ maxWidth: "750px" }}
                />
              </div>
            </li>

            {/* Step 3 */}
            <li className="mb-4">
              <strong>Step 3:</strong> Click{" "}
              <strong>“Create New API”</strong> → Add API Name and optionally
              add your <strong>Static IP</strong>.
              <div className="mt-3 text-center">
                <img
                  src="/assets/images/Pi42/Third.png"
                  alt="Create API"
                  className="img-fluid rounded shadow-sm"
                  style={{ maxWidth: "750px" }}
                />
              </div>
            </li>

            {/* IP Card */}
            <div className="card shadow-sm mb-4 border-0 rounded-3">
              <div className="card-body">
                <p className="mb-2">Use this IP address for secured API access:</p>
                <div className="alert alert-info m-0 fw-semibold">
                  {loading ? "Loading..." : company?.ip || "IP Not Found"}
                </div>
              </div>
            </div>
          </ol>
        </div>

        {/* Final Message */}
        <div className="card shadow-sm border-0 mt-4 mb-5">
          <div className="card-body text-center py-4">
            <h5 className="fw-bold mb-2">🎉 Your API Setup is Complete!</h5>
            <p className="text-muted mb-3">
              Now go to your <strong>Trading Panel</strong>, paste your API Key
              and Secret Key, select your IP, and you’re ready to start trading.
            </p>

           
          </div>
        </div>

      </div>
    </Content>
  );
};

export default Pi42;
